import axios from 'axios';
import { config } from '../../../config/env';
import { AcquisitionOffer, AuthenticatedOffer, UpgradeFeature, UpgradeOffers, UpgradeResult } from './types';

const baseUrl = config.jusfyBackend.apiUrl;
const acquisitionUrl = `${baseUrl}/pricing-catalog/acquisition`;
const offersUrl = `${baseUrl}/pricing-catalog/offers`;
const upgradeOffersUrl = `${baseUrl}/pricing-catalog/upgrade-offers`;
const upgradeUrl = `${baseUrl}/pricing-catalog/upgrade`;

export async function getAcquisitionOffers(coupon?: string): Promise<AcquisitionOffer[]> {
  const params = coupon ? { coupon } : undefined;
  const { data } = await axios.get<{ success: true; data: AcquisitionOffer[] }>(acquisitionUrl, { params });
  return data.data;
}

// jwtAuth: cliente vem do JWT (interceptor global já injeta o Bearer), sem
// query params.
export async function getAuthenticatedOffers(): Promise<AuthenticatedOffer[]> {
  const { data } = await axios.get<{ success: true; data: AuthenticatedOffer[] }>(offersUrl);
  return data.data;
}

export async function getUpgradeOffers(feature: UpgradeFeature): Promise<UpgradeOffers> {
  const { data } = await axios.get<{ success: true; data: UpgradeOffers }>(upgradeOffersUrl, { params: { feature } });
  return data.data;
}

export type UpgradeBody = {
  feature: UpgradeFeature;
  offer_id: number | string;
  recaptchaToken: string;
  card_id?: string;
  new_card?: {
    card_token: string;
    holder_name: string;
    brand: string;
    last_four: string;
    exp_month: string;
    exp_year: string;
  };
};

const HTTP_OK = 200;

// Only HTTP 200 with `status: 'confirmed'` is a confirmation. A 202, or any answer that does not say `confirmed`,
// is read as pending: the caller must prove the plan some other way before showing success.
export async function postUpgrade(body: UpgradeBody): Promise<UpgradeResult> {
  const { status, data } = await axios.post<{ success: true; data?: { status?: string } }>(upgradeUrl, body);
  const confirmed = status === HTTP_OK && data?.data?.status === 'confirmed';
  return { status: confirmed ? 'confirmed' : 'pending_confirmation' };
}
